// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M20,4c-0.6-0.6-1.5-1-2.4-1H6.4C5.5,3,4.6,3.4,4,4C3.4,4.6,3,5.5,3,6.4v11.3c0,0.9,0.4,1.8,1,2.4c0.6,0.6,1.5,1,2.4,1h11.2
	c1.9,0,3.4-1.5,3.4-3.4V6.4C21,5.5,20.6,4.6,20,4z M10.4,13.8c-1,1-2.5,1-3.5,0c-1-1-1-2.5,0-3.5c1-1,2.5-1,3.5,0
	C11.4,11.2,11.4,12.8,10.4,13.8z M17,13.8c-0.7,0.7-1.8,0.9-2.7,0.5c-0.9-0.4-1.5-1.3-1.5-2.3c0-1,0.6-1.9,1.5-2.3
	c0.9-0.4,2-0.2,2.7,0.5C18,11.2,18,12.8,17,13.8L17,13.8z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-flickr-square-BO5mtyle.js.map
